module.exports = __webpack_public_path__ + "static/media/ps-icon.594d155c.png";


//////////////////
// WEBPACK FOOTER
// ./src/ps-icon.png
// module id = 47
// module chunks = 0